import { render } from "./Answered.vue?vue&type=template&id=ccec574e&scoped=true&bindings={\"answered\":\"options\",\"answered_text\":\"options\",\"checkAnswer\":\"options\",\"linkTo\":\"options\"}"
import script from "./Answered.vue?vue&type=script&lang=js"
export * from "./Answered.vue?vue&type=script&lang=js"

import "./Answered.vue?vue&type=style&index=0&id=ccec574e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ccec574e"

export default script